//
// SignalR is imported via a script tag in _Layout.cshtml
//
declare var signalR: any;

import { useEffect, useState } from "react";

export type SignalRConnectionListeners = {
    onWorkPermitsUpdated?: () => any;
};

function useSignalR(listeners: SignalRConnectionListeners) {
    const [signalRConnection, setSignalRConnection] = useState<any>();

    useEffect(() => {
        function connect() {
            const connection = new signalR.HubConnectionBuilder().withUrl("/notifications").build();

            setSignalRConnection(connection);

            try {
                connection.start();
            } catch (err) {
                console.error("SignalR connection error: ", err);
            }

            return connection;
        }

        const connection = connect();

        return () => {
            if (!connection) {
                return;
            }

            connection.stop();
            setSignalRConnection(undefined);
        };
    }, []);

    useEffect(() => {
        setupConnectionListeners(signalRConnection, listeners);
    }, [signalRConnection, listeners])

    function setupConnectionListeners(connection: any, listeners: SignalRConnectionListeners) {
        if (!connection) {
            return;
        }

        connection.off("ReceiveNotification");

        connection.on("ReceiveNotification", async (message: string) => {
            if (message === "WorkPermitsUpdated" && listeners.onWorkPermitsUpdated) {
                listeners.onWorkPermitsUpdated();
            }
        });
    }

    return {};
}

export default useSignalR;
